import * as type from '../constants/hCaptcha';

export function validatehCaptchaToken(token, actions) {
    return {
        type: type.VALIDATE_HCAPTCHA_TOKEN,
        token,
        actions,
    };
}

export function validatehCaptchaTokenSuccess(result) {
    return {
        type: type.VALIDATE_HCAPTCHA_TOKEN_SUCCESS,
        result,
    };
}

export function validatehCaptchaTokenFail(error) {
    return {
        type: type.VALIDATE_HCAPTCHA_TOKEN_FAIL,
        error,
    };
}